import './App.css';
import {Grid} from '@mui/material'
import Pagina from "./Pagina/Pagina";
import '@fontsource/bricolage-grotesque/300.css'
import '@fontsource/bricolage-grotesque/400.css'
import '@fontsource/bricolage-grotesque/500.css'
import '@fontsource/bricolage-grotesque/600.css'
import '@fontsource/bricolage-grotesque/700.css'
import '@fontsource/bricolage-grotesque/800.css'

import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Landing from "./Landings_v2/Landins";

function App() {
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Router>
                <Routes>
                    <Route path={"*"} element={<Pagina/>}/>
                    <Route path={"/"} element={<Pagina/>}/>
                    <Route path={"Home"} element={<Pagina/>}/>
                    <Route path={"/:id"} element={<Landing/>}/>

                </Routes>
            </Router>

        </Grid>
    );
}

export default App;
